import { useNuxtApp } from "#app";
import { BaseService } from "../base/base.service";
import type { IModelResponse } from "../base/dto/base.dto";
import { ApplicationRepository } from "./application.repository";
import {
  ModelApplication,
  ModelApplicationAsso,
  ModelApplicationApiKey,
  type ImodeApplicationRequest,
} from "./dto/application.dto";

export class ApplicationService extends BaseService {
  private applicationRepository = new ApplicationRepository(
    this.api,
    this.configService
  );

  async getApplication(params: any): Promise<IModelResponse<ModelApplicationAsso[]>> {
    let dataResult: IModelResponse<ModelApplicationAsso[]> = {
      data: [],
    };
    const { $functions } = useNuxtApp();
    try {
      const res = await this.applicationRepository.getApplication(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        const dataList = (resData.data || []).map((e) => new ModelApplicationAsso(e));
        dataResult.data = dataList;
        dataResult.totalItems = resData.totalItems;
        console.log("getApplication", resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, ApplicationService.name);
    }
    return dataResult;
  }

  async getApplicationDetail(
    id: string | number
  ): Promise<ModelApplicationAsso> {
    let dataResult: ModelApplicationAsso = new ModelApplicationAsso();
    try {
      const { $functions } = useNuxtApp();
      const res = await this.applicationRepository.getApplicationAssoById(id);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelApplicationAsso(resData.data);
        console.log("getApplicationDetail", resData.data, dataResult);
      }
    } catch (err) {
      console.log(err, ApplicationService.name);
    }
    return dataResult;
  }

  async createApplication(
    params: ImodeApplicationRequest
  ): Promise<ModelApplicationAsso> {
    let dataResult: ModelApplicationAsso = new ModelApplicationAsso();
    try {
      const { $functions } = useNuxtApp();
      const res = await this.applicationRepository.createApplication(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelApplicationAsso(resData.data);
        console.log("createApplication", resData.data, dataResult);
      }
    } catch (err) {
      console.log(err, ApplicationService.name);
    }
    return dataResult;
  }

  async updateApplication(
    params: ImodeApplicationRequest
  ): Promise<ModelApplicationAsso> {
    let dataResult: ModelApplicationAsso = new ModelApplicationAsso();
    try {
      const { $functions } = useNuxtApp();
      const res = await this.applicationRepository.updateApplication(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelApplicationAsso(resData.data);
        console.log("updateApplication", resData.data, dataResult);
      }
    } catch (err) {
      console.log(err, ApplicationService.name);
    }
    return dataResult;
  }

  async changeStatusApplication(
    params: ImodeApplicationRequest
  ): Promise<ModelApplicationAsso> {
    let dataResult: ModelApplicationAsso = new ModelApplicationAsso();
    try {
      const { $functions } = useNuxtApp();
      const res = await this.applicationRepository.changeStatusApplication(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelApplicationAsso(resData.data);
        console.log("changeStatusApplication", resData.data, dataResult);
      }
    } catch (err) {
      console.log(err, ApplicationService.name);
    }
    return dataResult;
  }

  async createApiKey(applicationId: number, name: string): Promise<ModelApplicationApiKey> {
    let dataResult: ModelApplicationApiKey = new ModelApplicationApiKey();
    try {
      const { $functions } = useNuxtApp();
      const res = await this.applicationRepository.createApiKey(applicationId, name);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelApplicationApiKey(resData.data);
        console.log("createApiKey", resData.data, dataResult);
      }
    } catch (err) {
      console.log(err, ApplicationService.name);
    }
    return dataResult;
  }

  async deleteApiKey(apiKeyId: number): Promise<void> {
    try {
      const { $functions } = useNuxtApp();
      const res = await this.applicationRepository.deleteApiKey(apiKeyId);
      const resData = res.data.value;
      if (!$functions.isValidResponse(resData)) {
        throw new Error(resData?.message || 'Failed to delete API key');
      }
      console.log("deleteApiKey success");
    } catch (err) {
      console.log(err, ApplicationService.name);
      throw err;
    }
  }
  
  // async initialApplication(params: any): Promise<ModelApplicationDetail> {
  //   let dataResult: ModelApplicationDetail = new ModelApplicationDetail();
  //   try {
  //     const { $functions } = useNuxtApp()
  //     const res = await this.applicationRepository.initialApplication(params);
  //     const resData = res.data.value;
  //     if ($functions.isValidResponse(resData)) {
  //       dataResult = new ModelApplicationDetail(resData.data)
  //       console.log('initialApplication', resData.data, dataResult)
  //     }
  //   } catch (err) {
  //     console.log(err, ApplicationService.name);
  //   }
  //   return dataResult;
  // }

  // async appendApplication(params: any): Promise<ModelApplicationDetail> {
  //   let dataResult: ModelApplicationDetail = new ModelApplicationDetail();
  //   try {
  //     const { $functions } = useNuxtApp()
  //     const res = await this.applicationRepository.appendApplication(params);
  //     const resData = res.data.value;
  //     if ($functions.isValidResponse(resData)) {
  //       dataResult = new ModelApplicationDetail(resData.data)
  //       console.log('appendApplication', resData.data, dataResult)
  //     }
  //   } catch (err) {
  //     console.log(err, ApplicationService.name);
  //   }
  //   return dataResult;
  // }

  // async deleteApplication(params: any): Promise<ModelResponse> {
  //   let dataResult: ModelResponse = new ModelResponse();
  //   try {
  //     const { $functions } = useNuxtApp()
  //     const res = await this.applicationRepository.deleteApplication(params);
  //     const resData = res.data.value;
  //     if ($functions.isValidResponse(resData)) {
  //       dataResult = resData;
  //     }
  //   } catch (err) {
  //     console.log(err, ApplicationService.name);
  //   }
  //   return dataResult;
  // }
}
